import React, { Component } from 'react';
import {connect} from 'react-redux';
import {eapiClient, aemHostClient} from '../../../../restClient';
import {setLandingActiveTab} from '../../../CaseBody/actions/actionCreator';
import NavListAccordion, {NavListAccordionWrapper} from '../../../common/NavListAccordion/NavListAccordion';
import {Translations, convertStringToArrayForOption} from '../../../../utils';
import PropTypes from 'prop-types';
import BasicDetail from './basicDetails'
import Poolingstructure from './PoolingStructure'
import Othersettings from './otherSetting'
import Interestoptimisation from './interestOptimisation'
import EchannelReporting from './EchannelReporting'

import './PreviewNP.css';
// Notional pooling Preivew Request

class PreviewNP extends Component{
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data !== undefined ? this.props.data : {},
      metaData: {},
      title: false,
      originalData:this.props.echannels !== undefined ? this.props.echannels : undefined
    };
  }

  translations = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    return currentWord;
  }

  translateWordForOption = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  componentWillMount(){

    if(this.props.match !== undefined){
      var {caseId} = this.props.match.params;
      eapiClient(`/product/gls/${caseId}/preview-request`, {method: 'GET'})
      .then(({data}) => {
        // gls
        this.setState({
          data: data.responseData,
          title: true
        })
        this.state.originalData === undefined && eapiClient(`/cases/${data.responseData.caseId}/previewRequest`, {method: 'GET'})
        .then(({data, status}) => {

           this.setState({
             originalData : data.responseData.productDetails.eChannels !== undefined &&  data.responseData.productDetails.eChannels.length > 0 ?  data.responseData.productDetails.eChannels : []
           });
          });
      });
    }

  aemHostClient("/aemData/formData/json_preview-notional-pooling")
    .then(({data, status}) => {
      let heading='Notional Pooling';
      document.title = `${heading} - ${'HSBC GLCM'}`;
      this.setState({
       metaData: data.par
      })
      //this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase,this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", currentCase);
    });

    aemHostClient("/aemData/formData/json_dark-title-bar")
    .then(({data, status}) => {
      //this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase,this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", currentCase);
    });

    aemHostClient("/aemData/formData/json_preview-request-open")
    .then(({data, status}) => {
      this.setState({
       pageJson:data.par
      })
    });


  }

  getCountryTaxonomy=(item)=>{
    if(this.props.countryList !== undefined){
              this.props.countryList.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.country.value) {
                    item.country.name = countItem.name
                    }
                  }else{
                    if (countItem.id === item.value) {
                      item.name = countItem.name
                      }
                  }
                })
                return item;
              }
      }

      getProductRelatedTaxonomy(product){
        if (product !== undefined) {
           this.props.accountCountryList.filter(countItem => {
              if ('country' in product) {
                if (countItem.id === product.country.value) {
                  product.country.name = countItem.name
                    if(product.accountType !== undefined){
                      countItem.associations.filter(accountType =>
                      {
                      if(accountType.id === product.accountType.value){
                        product.accountType.name = accountType.name
                          }
                      })
                  }} }
            });
            return product;
    }
    }
    
  eventToGoCase = () => {
    this.props.setLandingActiveTab(1);
    this.props.history.push('/case-list');
  }

    render(){

      const tabTitleHtml = (
        <div className="ie-navigation">
           <div className="title">
              {
                this.state.metaData !== undefined && this.state.metaData.staticText_previewData !== undefined
                ? `${this.translations(this.state.metaData.staticText_previewData.title)} >`
                : `Notional Pooling  > `
              }
           </div>
           <span>{`${this.state.data.glsAgent !== undefined ? this.state.data.glsAgent.name : ''}`}</span>
         </div>
       );

      if(this.state.pageJson !== undefined && this.state.metaData !== undefined && Object.keys(this.state.data).length !== 0 && this.state.data !== undefined){
        return (
          <div className="np-preview-request-container">
            <div className="gdoc-preview-request-content">
              {
                this.state.title &&
                <div className="gdoc-preview-request-preview-request border-bottom-none">
                  <span>
                  {
                    this.state.metaData.staticText_previewData !== undefined
                    ? `${this.translations(this.state.metaData.staticText_previewData.title)}`
                    : ''
                  }
                  </span>
                </div>
              }
              <div className="np-container">
                <NavListAccordionWrapper>
                  <NavListAccordion
                    navAccHeading={tabTitleHtml}
                  >
                    {
                      this.state.metaData !== undefined && this.state.metaData.staticText_previewBasicDetail !== undefined
                      ? <BasicDetail
                          data={this.state.data}
                          pageJson={this.state.metaData.staticText_previewBasicDetail}
                          translations={(word) => this.translations(word)}
                          countryList= {this.props.countryList}
                          getCountryTaxonomy={(item) => this.getCountryTaxonomy(item)}
                        />
                      : null
                    }

                    {
                      this.state.metaData !== undefined && this.state.metaData.staticText_previewPoolingStructure !== undefined
                        ? <Poolingstructure
                            data={this.state.data}
                            translations={(word) => this.translations(word)}
                            newAccounts={this.props.newAccounts}
                            pageJson={this.state.metaData.staticText_previewPoolingStructure}
                            accountCountryList= {this.props.accountCountryList}
                            getProductRelatedTaxonomy={(item) => this.getProductRelatedTaxonomy(item)}
                          />
                        : null
                    }
                    {
                      this.state.metaData !== undefined && this.state.metaData.static_text_eChannelReporting !== undefined &&
                      this.state.data.notionalPooling !== undefined
                      ? <EchannelReporting
                          data={this.state.data}
                          echannels={this.state.originalData}
                          translations={(word) => this.translations(word)}
                          pageJson={this.state.metaData.static_text_eChannelReporting}
                          countryList= {this.props.countryList}
                          getCountryTaxonomy={(item) => this.getCountryTaxonomy(item)}
                        />
                      : null
                    }
                    {
                      this.state.metaData !== undefined && this.state.metaData.staticText_previewOtherSettings !== undefined
                      ? <Othersettings
                          data={this.state.data}
                          pageJson={this.state.metaData.staticText_previewOtherSettings}
                          translations={(word) => this.translations(word)}
                        />
                      : null
                    }
                    {
                      this.state.metaData !== undefined && this.state.metaData.staticText_previewInterestOptimisation !== undefined
                      ? <Interestoptimisation
                          data={this.state.data}
                          pageJson={this.state.metaData.staticText_previewInterestOptimisation}
                          translations={(word) => this.translations(word)}
                          translateWordForOption={(word) => this.translateWordForOption(word)}
                          poolingStructurePageJson = {this.state.metaData.staticText_previewPoolingStructure}
                          accountCountryList= {this.props.accountCountryList}
                          getProductRelatedTaxonomy={(item) => this.getProductRelatedTaxonomy(item)}
                        />
                      : null
                    }
                  </NavListAccordion>
                </NavListAccordionWrapper>
              </div>
              <div className="gdoc-supportdoc-footer-btn ie-footer-button">
                <button
                  onClick={() => this.eventToGoCase()}
                  className="gdocs-btn-primary case-history-btn"
                  name="supportingDoc"
                >
                  {Translations(this.state.pageJson.button_addnbutton.text,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </button>
              </div>
            </div>
          </div> )
      }else {
        return (<div>Loading...</div>);
      }
    }
  }
    PreviewNP.propTypes = {
      data :  PropTypes.object
  }

  const mapStateToProps = state => {
    return {
      lang: state.lang
    }
  }

  const mapDispatchToProps = dispatch => {
    return {
      setLandingActiveTab: (activeTabId) => {
        dispatch(setLandingActiveTab(activeTabId));
      },
    }
  }
  export default connect(mapStateToProps, mapDispatchToProps)(PreviewNP);



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/NPPreview/PreviewNP.js